<template>
  <div>

    <vs-row>
      <vs-col class="">
        <h5 class="mb-4">Q&A</h5>
      </vs-col>
    </vs-row>
    <vs-row class="w-full mb-4">
      <vs-col class="w-1/2 pr-1">
        <vs-button class="w-full" color="secondary" type="border" @click="back">뒤로</vs-button>
      </vs-col>
      <vs-col class="w-1/2 pl-1">
        <vs-button class="w-full" color="secondary" @click="register">수정</vs-button>
      </vs-col>
    </vs-row>

    <vx-card>

      <vs-row>
        <vs-col class="">
          <h5 class="mb-4"><i class="dot"></i>Q&A</h5>
        </vs-col>
      </vs-row>

      <vs-row class="mb-8">
        <vs-col class="flex flex-wrap">
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 60px 1fr;">
            <vs-col >제목</vs-col>
            <vs-col>
              <vs-input class="w-full" v-model="form.post_title"/>
            </vs-col>
          </vs-row>
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 60px 1fr;">
            <vs-col >작성자</vs-col>
            <vs-col>
              <vs-input class="w-full" v-model="form.writer" :readonly="true"/>
            </vs-col>
          </vs-row>

          <vs-row class="w-full mb-4" vs-align="center" vs-justify="center" >
            <vs-col class="mb-2">내용</vs-col>
            <vs-col>
              <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
            </vs-col>
          </vs-row>


          <file-upload-module class="w-full" :isShowTitle="true" type="check_list_col" v-model="fileList"></file-upload-module>

        </vs-col>
      </vs-row>


    </vx-card>
  </div>
</template>

<script>

import FileUploadModule from '@/views/modules/FileUploadModule'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'MobileCommunityQnaUpdate',
  components: {
    FileUploadModule,
    quillEditor
  },
  data () {
    return {
      boardSlug: 'qna',
      boardId: 17,

      quillOption: {
        placeholder: '내용을 입력해주세요'
      },

      form: {
        post_title: '', //사무소명
        writer: '', //작성자
        content: ''
      },
      fileList: []
    }
  },

  created () {
    this.loadPost()
  },

  methods:{
    back () {
      this.$router.back()
    },

    async loadPost () {
      const boardId = this.boardId
      const postId = this.$route.params.postId
      await this.$store.dispatch('board/LOAD_POST', {boardId, postId})

      // 내용
      const post = this.$store.state.board.postInfo
      this.form = JSON.parse(post.post_content)
      this.form.post_title = post.post_title
      const files = post.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }
    },

    async register () {
      const boardId = this.boardId
      const postId = this.$route.params.postId
      const title = this.form.post_title

      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      const content = JSON.stringify(this.form)

      if (this.formCheck()) {
        await this.$store.dispatch('board/UPDATE_POST', {boardId, postId, title, content, uploads})

        this.$router.back()
      }

    },

    formCheck () {
      if (this.form.post_title.trim().length <= 0) {
        alert('제목을 입력해주세요')
        return false
      }

      return true
    }
  }
}
</script>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
